import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
        if (data.company) {
            datas.company = data.company
        }
    }
    return ApiService.get('/transport/transport-services/', datas)
}
export const createApiRecord = (data) =>
    ApiService.post('/transport/transport-services/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/transport/transport-services/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.patch(`/transport/transport-services/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/transport/transport-services/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/transport/transport-services', id)
export const calculateApiRecord = (data) =>
    ApiService.post('/rate-card-template/dynamic-calculation/', data)
